module.exports = __webpack_public_path__ + "188f9678ba3a2399eadef1f670c4c570.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-82@2x.png
// module id = 539
// module chunks = 0